import "../../style/scss/App.scss";
import { DateTime } from "luxon";

export default function PersonAgreementListItem({ agreement, onView }) {
  const a = agreement || {};
  const id = a.ID ?? a.id ?? a.AgreementID ?? a.agreementID;
  const acceptedDate = a.DateAccepted
    ? DateTime.fromISO(a.DateAccepted).toFormat("MM/yyyy")
    : "Now";

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`agreement-list-item-${id}`}
        onClick={() => onView?.(a)}
      >
        <div className="Job mobilePanel">
          <span className="title">{a.Name || a.name || "Agreement"}</span>
          <span className="rightText">{acceptedDate}</span>
        </div>
      </button>
    </li>
  );
}
